<template>
  <div class="add">
    <header class="headet-title">
      <div class="headet-title-box">银行卡添加</div>
    </header>
    <div class="add-body">
      <el-form :model="addForm" label-width="180px" style="padding-left:40px;">
        <el-form-item label="企业名称：">
          <!-- <el-input v-model="addForm.companyName" style="width:450px" disabled /> -->
          <div>
            <span :class="addForm.companyName ? 'spanInline' : 'isWdth'">{{ addForm.companyName }}</span>
          </div>
        </el-form-item>
        <el-form-item label="社会信用代码证：">
          <el-input v-model="addForm.tradeLicenseNo" class="w200" disabled />
        </el-form-item>
        <el-form-item label="账号类型：">
          <el-radio-group v-model="radio">
            <el-radio :label="1">对公基本户</el-radio>
            <el-radio :label="2">对公一般户</el-radio>
            <el-radio :label="3">对私法人户</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="开户银行：">
          <el-select v-model="bankName" filterable clearable placeholder="请选择输入银行" @change="selectBank">
            <el-option
              v-for="item in bankListOption"
              :key="item.id"
              :label="item.bankName"
              :value="item.bankName"
            />
          </el-select>
        </el-form-item>
        <span v-if="radio===1||radio===2">
          <el-form-item label="开户城市：" class="linkBy">
            <el-select
              v-model="addForm.bankProvNo"
              placeholder="省"
              style="display:inline-block;width:140px;"
              @change="getRegCityData"
            >
              <el-option v-for="item in addressArray" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
            <el-select
              v-model="addForm.bankCityNo"
              placeholder="市"
              style="display:inline-block;width:140px;"
              @change="getRegCountyData"
            >
              <el-option v-for="item in regProvinceArray" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
            <el-select
              v-model="addForm.bankCountiesNo"
              placeholder="区"
              style="display:inline-block;width:140px;"
              @change="getRegregTown"
            >
              <el-option v-for="item in regCountyArray" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
          </el-form-item>
          <el-form-item label="开户支行：">
            <el-select
              v-model="addForm.bankBranch"
              clearable
              placeholder="请选择支行名称"
              :disabled="unshow"
              style="width:400px"
              value-key="id"
              @change="selectBankbranch"
            >
              <el-option
                v-for="item in bankbranchListOption"
                :key="item.bankNo"
                :label="item.bankName"
                :value="item"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="账号名称：">
            <el-input v-model="addForm.accountName" disabled  placeholder="现代支付基本户" class="w210" />
          </el-form-item>
          <el-form-item label="银行账号：">
            <el-input v-model="addForm.bankCardNo" class="w200" />
          </el-form-item>
        </span>
        <span v-if="radio===3">
          <el-form-item label="真实姓名：">
            <el-input v-model="addForm.legalName" class="w200" />
          </el-form-item>
          <el-form-item label="身份证号：">
            <el-input v-model="addForm.legalIdCard" class="w200" />
          </el-form-item>
          <el-form-item label="银行卡：">
            <el-input v-model="addForm.bankCardNo" class="w200" />
          </el-form-item>
          <el-form-item label="预留手机：">
            <el-input v-model="addForm.bankPhone" class="w200" />
          </el-form-item>
        </span>
        <span v-if="radio===1">
          <el-form-item label="开户许可证或相关证明：">
            <el-upload
              ref="upload"
              class="upload-demo"
              action="https://jsonplaceholder.typicode.com/posts/"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :file-list="fileList"
              :auto-upload="false"
            >
              <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
              <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
            </el-upload>
          </el-form-item>
        </span>
        <div v-if="radio===3 && (bankName=='邮政储蓄银行' || bankName=='中国邮政储蓄银行')"
        class="fz12 pb-50"
        style="padding-left:160px;"
        @click="openAgree()"
      >
        <el-checkbox
          v-model="loginForms.checked"
          style="display:inline-block"
        />
        <span class="colodRed">《中国邮政储蓄银行借记卡快捷支付业务线上服务协议》</span>
      </div>
        <el-form-item class="pb-50">
          <span v-if="radio===1">
            <el-button type="primary" @click="submit('01')">确定</el-button>
          </span>
          <span v-if="radio===2">
            <el-button type="primary" @click="submit('02')">确定</el-button>
          </span>
          <span v-if="radio===3">
            <el-button type="primary" @click="submit('03')">确定</el-button>
          </span>
        </el-form-item>
      </el-form>
      <agree ref="agree" />
    </div>
  </div>
</template>
<script>
import { bankCardAddBus, getBankList, getBranchBankList, initAddBus } from '@/api/bankcard/bankcard'
import { getArea } from '@/api/common/common'
import Session from '@/utils/session'
import agreeMent from '../bank-card/agreement.vue'
import { getCompanyInfo } from '@/api/info'
import { SelectCertificateOnClick, SignOnClick } from '@/utils/CryptoKit'

export default {
  name: 'AddBus',
  components: {
    agree: agreeMent
  },
  data() {
    return {
      loginForms: {
        checked: true
      },
      radio: 1,
      bankName: null,
      addForm: {
        accountBankInfo: null,
        customerId: Session.getItem('customerId'),
        companyName: null,
        tradeLicenseNo: null,
        bankCardNo: null,
        // 省
        bankProv: null,
        bankProvNo: null,
        // 市
        bankCity: null,
        bankCityNo: null,
        // 区
        bankCounties: null,
        bankCountiesNo: null,
        bankBranch: null,
        accountBankNo: null,
        nuccCode: null,
        legalName: null,
        legalIdCard: null,
        bankPhone: null,
        source: '03',
        defaultCard: '0',
        defaultSettleCard: '0'
      },
      tradeLicenseNo: null,
      unshow: true,
      bankListOption: [],
      bankbranchListOption: [],
      fileList: [],
      addressArray: [],
      regProvinceArray: [],
      regCountyArray: []
    }
  },
  created() {
    this.bankList()
    this.getArea()
    this.init()
    this.getData()
  },
  methods: {
    selectBankbranch(v) {
      this.addForm.bankBranch = v.bankName
      this.addForm.bankBranchNo = v.bankNo
      this.addForm.accountBankInfo = v.bankName
      this.addForm.linkBankNo = v.bankNo
      console.log(v)
    },
    // 显示协议书
    openAgree() {
      this.$refs.agree.open()
    },
    selectBank(bankName) {
      const result = this.bankListOption.filter(item => item.bankName === bankName)
      if (result.length > 0) {
        this.addForm.accountBankNo = result[0].bankCode
        this.addForm.nuccCode = result[0].nuccCode
      }
      this.addForm.bankProvNo = null
      this.addForm.bankCityNo = null
      this.addForm.bankCountiesNo = null
      this.addForm.bankBranch = null
      this.bankbranchListOption = []
    },
    submit(type) {
      // this.bankListOption.forEach((item) => {
      //   if (item.bankCode === this.addForm.accountBankNo) {
      //     this.addForm.nuccCode = item.nuccCode
      //   }
      // })
      if (type === '03') {
        this.addForm.bankBranch = null
        this.addForm.bankBranchNo = null
        this.addForm.linkBankNo = null
        this.addForm.accountBankInfo = null
      }
      const otherParam = {
        accountType: type
      }
      const signKeys = ['bankCardNo', 'legalName', 'legalIdCard', 'bankPhone']
      const param = Object.assign({}, this.addForm, otherParam)
      param.isCfcaDecrypt = SelectCertificateOnClick()
      for (const item of signKeys) {
        if (this.addForm[item]) {
          param[item] = SignOnClick(this.addForm[item]).result
        }
      }
      bankCardAddBus(param).then(res => {
        this.$message({
          message: '添加银行卡成功',
          type: 'success'
        })
        this.$router.push({ name: 'bank-card' })
      }).catch(error => {
        console.log(error) // 请求失败返回的数据
      })
    },
    init() {
      const param = {
        customerId: this.addForm.customerId
      }
      initAddBus(param).then(res => {
        // console.log(res)
        // this.companyName = res
        // this.tradeLicenseNo = res
      })
    },
    bankList() {
      const param = {
        orgType: '01',
        pageNum: 1,
        pageSize: 9999
      }
      getBankList(param).then(res => {
        this.bankListOption = res.data.list
      }).catch(error => {
        console.log(error) // 请求失败返回的数据
      })
    },
    // 获取企业基本信息
    getData() {
      const param = {
        customerId: this.addForm.customerId
      }
      getCompanyInfo(param).then(res => {
        this.addForm.companyName = res.data.companyName
        this.addForm.tradeLicenseNo = res.data.tradeLicenseNo
        this.addForm.accountName = res.data.companyName
        this.addForm.legalName = res.data.corporationName
        this.addForm.legalIdCard = res.data.corporationIdCardNo
      })
        .catch(error => {
          console.log(error) // 请求失败返回的数据
        })
    },
    // 获取省
    getArea() {
      const param = {}
      getArea(param)
        .then(res => { this.addressArray = res.data.children })
        .catch(error => { console.log(error) })
    },
    // 注册地址市
    getRegCityData(val) {
      this.regProvinceArray = []
      this.regCountyArray = []
      this.addForm.bankCityNo = null
      this.addForm.bankCountiesNo = null
      for (const item of this.addressArray) {
        if (item.id === val) {
          this.addForm.bankCity = item.name
        }
      }
      const param = { id: val }
      getArea(param)
        .then(res => {
          this.regProvinceArray = res.data.children
        })
        .catch(error => { console.log(error) })
    },
    // 注册区
    getRegCountyData(val) {
      this.regCountyArray = []
      this.addForm.bankCountiesNo = null
      for (const item of this.regProvinceArray) {
        if (item.id === val) {
          this.addForm.bankCounties = item.name
        }
      }
      const param = { id: val }
      getArea(param)
        .then(res => {
          // console.log(res)
          this.regCountyArray = res.data.children
        })
        .catch(error => { console.log(error) })
    },
    // 支行事件
    getRegregTown(val) {
      for (const item of this.regCountyArray) {
        if (item.id === val) {
          this.addForm.regTownName = item.name
        }
      }
      if (this.addForm.accountBankNo !== null && this.addForm.bankCity !== null && this.addForm.bankCounties !== null) {
        this.unshow = false
      }
      const param = {
        pageNum: 1,
        pageSize: 9999,
        headBankCode: this.addForm.accountBankNo,
        provinceName: this.addForm.bankCity,
        cityName: this.addForm.bankCounties
      }
      getBranchBankList(param).then(res => {
        this.bankbranchListOption = res.data.list
        // console.log(this.bankbranchListOption)
      }).catch(error => {
        console.log(error) // 请求失败返回的数据
      })
    },
    handlePreview() { },
    handleRemove() { }
  }
}
</script>
<style>
.bN .el-input__inner {
  border: none;
}
</style>
<style scoped>
.headet-title {
  padding: 10px 30px 20px 30px;
}
.headet-title .headet-title-box {
  font-size: 16px;
  padding: 10px 0;
  border-bottom: 1px solid #dbdde2;
}
.w200 {
  width: 200px;
}
.w210 {
  width: 210px;
}
.color6 {
  color: #828282;
}
.fz12 {
  font-size: 12px !important;
}
.pb-50 {
  padding-bottom: 50px;
}
.linkBy .el-form-item__content {
  margin-left: 0;
}
.spanInline{
  background-color: #F5F7FA;
  border-color: #E4E7ED;
  color: #C0C4CC;
  border: 1px solid #DCDFE6;
  padding: 0 15px;
  border-radius: 4px;
  display: inline-block;
  box-sizing:border-box;
  min-width: 200px;
}
.isWdth{
  background-color: #F5F7FA;
  border-color: #E4E7ED;
  color: #C0C4CC;
  border: 1px solid #DCDFE6;
  padding: 0 15px;
  border-radius: 4px;
  display: inline-block;
  min-width: 200px;
  height: 40px;
  box-sizing:border-box
}
</style>
